// extracted by mini-css-extract-plugin
module.exports = {"container":"map-location_container__21QP7","lastLocation":"map-location_lastLocation__2P92a","map":"map-location_map__3jflj"};